// extracted by mini-css-extract-plugin
export default {"emptyNote":"NoteManagement_emptyNote__lECBe","buttonWrapper":"NoteManagement_buttonWrapper__4FWLC"};